import { GzRmTopFindingsSeverityWidgetWebComponent } from './component/GzRmTopFindingsSeverityWidgetWebComponent';

export { GzRmTopFindingsSeverityWidgetWebComponent };
